import React from 'react';
import { Modal, Button, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import TextTypography from '../../../../../shared/Typography/Text';
import HeadingTypography from '../../../../../shared/Typography/Heading';

interface ProductReportProps {
  visible: boolean;
  onClose: () => void;
  data: any[];
}

interface ProductData {
  date: string;
  vendorName: string;
  productType: string;
  brand: string;
  model: string;
  color: string;
  purchasePrice: string;
}

const ProductReport = ({ visible, onClose, data }: ProductReportProps) => {
  const formattedData: ProductData[] = data.flatMap(item => {
    return item.products.map((product: any) => ({
      date: new Date(item.created_at).toLocaleDateString(),
      vendorName: item.vendor?.vendor_name || '-',
      productType: product.product_type?.name || '-',
      brand: product.brand?.name || '-',
      model: product.product_name || '-',
      color: product.color?.name || '-',
      purchasePrice: `PKR ${product.purchase_price}`,
    }));
  });

  const columns: ColumnsType<ProductData> = [
    { title: 'Date', dataIndex: 'date', key: 'date' },
    { title: 'Vendor Name', dataIndex: 'vendorName', key: 'vendorName' },
    { title: 'Product Type', dataIndex: 'productType', key: 'productType' },
    { title: 'Brand', dataIndex: 'brand', key: 'brand' },
    { title: 'Model', dataIndex: 'model', key: 'model' },
    { title: 'Color', dataIndex: 'color', key: 'color' },
    { title: 'Purchase Price', dataIndex: 'purchasePrice', key: 'purchasePrice' },
  ];

  const handlePrint = () => window.print();
  const handleDownload = () => alert('Download functionality not implemented yet.');

  return (
    <Modal
      title="View Report"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      className="custom-modal"
    >
      <div className="flex items-center justify-center">
        <div className='flex flex-col'>
          <HeadingTypography fontSize={24}>Kal Technologies Pvt Ltd</HeadingTypography>
          <TextTypography fontSize={24} classNames="mt-2">Product Report</TextTypography>
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={formattedData}
        pagination={false}
        rowKey={(record, idx) => `${record.model}-${idx}`}
        size="middle"
        className="mt-4"
      />

      <div className="flex justify-between mt-4">
        <TextTypography fontSize={16}>Generated on: {new Date().toLocaleString()}</TextTypography>
        <div className="flex gap-4">
          <Button className="bg-white text-[#4A4747] px-5 rounded-lg w-[115px] h-[40px] hover:bg-[#f1f1f1] hover:text-black" onClick={handlePrint}>Print</Button>
          <Button className="bg-[#BD273B] text-white hover:bg-[#9d1f2f] hover:border-[#BD273B] px-5 rounded-lg w-[115px] h-[40px]" onClick={handleDownload}>Download</Button>
        </div>
      </div>
    </Modal>
  );
};

export default ProductReport;
